import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import Styles from './styles.scss';

export default class AabAmount extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.amount = '0';
    this.currency = 'EUR';
    this.locale = 'nl-NL';
    this.color = '';
    this.prefix = false;
    this.symbol = false;
  }

  static get properties() {
    return {
      amount: { type: String, attribute: true, reflect: true },
      currency: { type: String, attribute: true, reflect: true },
      locale: { type: String, attribute: true, reflect: true },
      prefix: { type: Boolean, reflect: true},
      symbol: { type: Boolean, reflect: true},
      color: { type: String, attribute: true, reflect: true },
      noFormatting: { type: Boolean, attribute: 'no-formatting', reflect: true },
    };
  }

  static get styles() {
    return [Styles];
  }

  renderCurrency(currency) {
    return html`<span class="${this.prefix && this.symbol ? 'amount-symbol' : 'currency'}">${currency}</span>`;
  }

  static localeDecimalSeparator(locale) {
    return `${new Intl.NumberFormat(locale).format(1 / 2)}`.charAt(1);
  }

  renderAmount(isPositive, intAmount, decimalAmount, decimalCharacter) {
    const style = this.color ? `color: ${this.color}` : '';
    return html`<span style="${style}" class="${this.prefix ? 'sml-1 amount-symbol' : 'mr-1 amount'}">${isPositive ? intAmount : `-${intAmount}`}${decimalAmount
      ? html`${decimalCharacter}<span class="decimal" >${decimalAmount}</span>` : ''}</span>`;
  }

  render() {
    const amount = Math.abs(this.amount);
    const isPositive = `${amount}` === `${Number.parseFloat(this.amount)}`;
    // Intl locale is not supported in IE
    const indicator = this.symbol ? 'symbol' : 'code';
    const formattedAmount = new Intl.NumberFormat( this.locale,
      { style: 'currency', currency: this.currency,  currencyDisplay: indicator}).format(amount);
    const amountNumbers = formattedAmount.replace(/[^\d.,]+/, '');
    const decimalCharacter = AabAmount.localeDecimalSeparator(this.locale);
    const splitAmount = amountNumbers.split(decimalCharacter);
    const renderedAmount = this.renderAmount(isPositive, splitAmount[0], splitAmount[1], decimalCharacter);
    const renderedCurrency = this.renderCurrency(formattedAmount.replace(/[\d.,]+/, '').trim());

    return html`<span class="amount-wrapper ${this.noFormatting ? '' : 'formatted'}">
    ${this.prefix ? html`${renderedCurrency}${renderedAmount}` :  html`${renderedAmount}${renderedCurrency}`}</span>`;
  }
}
